import { Carousel } from 'primereact/carousel'
import styled from 'styled-components'

export const StyledCarousel = styled(Carousel)`
    .p-carousel-prev,
    .p-carousel-next {
        display: none;
    }

    .p-carousel-indicators {
        display: none;
    }
`

export const Title = styled.div`
    font-size: 42px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    margin-bottom: 2rem;

    @media (max-width: 768px) {
        font-size: 24px;
        margin-top: 1.5rem;
        margin-bottom: 0.5rem;
    }
`
